export const DOCUMENT_STATUS = {
  WAITING_FOR_QUOTATION_APPROVAL: 'Waiting for Quotation Approval',
  WAITING_FOR_DELIVERY: 'Waiting for Delivery',
  WAITING_FOR_APPROVAL: 'Waiting for Approval',
  WAITING_FOR_CORRECTION: 'Waiting for Correction',
  APPROVED: 'Approved',
  ARCHIVED: 'Archived',
  DELETED: 'Deleted',
  PROCESSING: 'Processing',
  PRE_PROCESSING: 'Pre-processing',
  ERROR: 'Error',
  IN_PROGRESS: 'In Progress',
  DELIVERED: 'Delivered',
  INVOICED: 'Invoiced',
  CANCELLED: 'Cancelled',
  DRAFT: 'Draft',
  WAITING_FOR_ORDER: 'Waiting for Order',
  ORDER_APPROVED: 'Order Approved',
  INVALIDATED: 'Invalidated',
  REJECTED: 'Rejected',
  ON_HOLD: 'On Hold',
  AVAILABLE: 'Available',
  READY: 'Ready'
} as const;

export const CLAIM_SCORING_STATUS = {
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable',
  PENDING: 'pending'
} as const;
